module.exports = __webpack_public_path__ + "static/tide-commercial_icons-3059cb4e2d05333285ddcf9bbc554666.svg";